 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"associations~awards~clubInfo~competitions~competitionsEventView~competitionsView~dashboard~disciplin~7bb74a4e":"associations~awards~clubInfo~competitions~competitionsEventView~competitionsView~dashboard~disciplin~7bb74a4e","associations~members":"associations~members","members":"members","associations~supportTeam~users":"associations~supportTeam~users","associations":"associations","supportTeam":"supportTeam","users":"users","awards":"awards","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~events~questionTypes":"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~events~questionTypes","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes~wavesCompetitionsReports":"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes~wavesCompetitionsReports","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes":"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes","clubInfo":"clubInfo","competitions":"competitions","competitionsEventView":"competitionsEventView","competitionsView":"competitionsView","dqCodes":"dqCodes","questionTypes":"questionTypes","events":"events","wavesCompetitionsReports":"wavesCompetitionsReports","dashboard":"dashboard","disciplines":"disciplines","divisions":"divisions","pointsTable":"pointsTable","reports":"reports","tutorials":"tutorials","wavesCompetitionsEntries":"wavesCompetitionsEntries","wavesCompetitionsEventProgress":"wavesCompetitionsEventProgress","wavesCompetitionsMarshalling":"wavesCompetitionsMarshalling","wavesCompetitionsWavesResults":"wavesCompetitionsWavesResults","documentation":"documentation","login":"login","siteSettings":"siteSettings","slsnz":"slsnz","userProfile":"userProfile","waves":"waves"}[chunkId]||chunkId) + "." + {"associations~awards~clubInfo~competitions~competitionsEventView~competitionsView~dashboard~disciplin~7bb74a4e":"234787a7","associations~members":"5ad199a9","members":"8beed546","associations~supportTeam~users":"80158b54","associations":"1053fcfd","supportTeam":"22391172","users":"391f74f3","awards":"233811fc","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~events~questionTypes":"056d0cbd","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes~wavesCompetitionsReports":"0da1159f","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes":"c95db067","clubInfo":"3d7d7473","competitions":"aab7c1bc","competitionsEventView":"026dea5a","competitionsView":"925a5fc6","dqCodes":"73a51e4c","questionTypes":"ee4e8155","events":"9b365f8b","wavesCompetitionsReports":"3c871613","dashboard":"a59d3ffc","disciplines":"d543692c","divisions":"bd73f48d","pointsTable":"fe20349a","reports":"69733ca0","tutorials":"3a85250f","wavesCompetitionsEntries":"7d1a4928","wavesCompetitionsEventProgress":"85474c6f","wavesCompetitionsMarshalling":"07890e95","wavesCompetitionsWavesResults":"13ff68d0","documentation":"c7590176","login":"611236d1","siteSettings":"bd9b4332","slsnz":"075a2cef","userProfile":"b3adf293","waves":"9f683da3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"associations~awards~clubInfo~competitions~competitionsEventView~competitionsView~dashboard~disciplin~7bb74a4e":1,"associations~members":1,"members":1,"associations":1,"supportTeam":1,"users":1,"awards":1,"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~events~questionTypes":1,"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes":1,"clubInfo":1,"competitions":1,"competitionsEventView":1,"competitionsView":1,"dqCodes":1,"questionTypes":1,"events":1,"wavesCompetitionsReports":1,"dashboard":1,"disciplines":1,"divisions":1,"pointsTable":1,"reports":1,"tutorials":1,"wavesCompetitionsEntries":1,"wavesCompetitionsEventProgress":1,"wavesCompetitionsMarshalling":1,"wavesCompetitionsWavesResults":1,"login":1,"siteSettings":1,"slsnz":1,"userProfile":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"associations~awards~clubInfo~competitions~competitionsEventView~competitionsView~dashboard~disciplin~7bb74a4e":"associations~awards~clubInfo~competitions~competitionsEventView~competitionsView~dashboard~disciplin~7bb74a4e","associations~members":"associations~members","members":"members","associations~supportTeam~users":"associations~supportTeam~users","associations":"associations","supportTeam":"supportTeam","users":"users","awards":"awards","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~events~questionTypes":"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~events~questionTypes","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes~wavesCompetitionsReports":"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes~wavesCompetitionsReports","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes":"clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes","clubInfo":"clubInfo","competitions":"competitions","competitionsEventView":"competitionsEventView","competitionsView":"competitionsView","dqCodes":"dqCodes","questionTypes":"questionTypes","events":"events","wavesCompetitionsReports":"wavesCompetitionsReports","dashboard":"dashboard","disciplines":"disciplines","divisions":"divisions","pointsTable":"pointsTable","reports":"reports","tutorials":"tutorials","wavesCompetitionsEntries":"wavesCompetitionsEntries","wavesCompetitionsEventProgress":"wavesCompetitionsEventProgress","wavesCompetitionsMarshalling":"wavesCompetitionsMarshalling","wavesCompetitionsWavesResults":"wavesCompetitionsWavesResults","documentation":"documentation","login":"login","siteSettings":"siteSettings","slsnz":"slsnz","userProfile":"userProfile","waves":"waves"}[chunkId]||chunkId) + "." + {"associations~awards~clubInfo~competitions~competitionsEventView~competitionsView~dashboard~disciplin~7bb74a4e":"48079e9c","associations~members":"fae767bb","members":"e521cfe9","associations~supportTeam~users":"31d6cfe0","associations":"cbb6b2f3","supportTeam":"bd1b9bd5","users":"22c22907","awards":"bfb6e5ce","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~events~questionTypes":"5c28bb04","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes~wavesCompetitionsReports":"31d6cfe0","clubInfo~competitions~competitionsEventView~competitionsView~dqCodes~questionTypes":"1ff8eca4","clubInfo":"2fe25618","competitions":"6b55f296","competitionsEventView":"cc32bd4b","competitionsView":"864d795c","dqCodes":"129e2129","questionTypes":"1cb8a7c2","events":"eef9f8c8","wavesCompetitionsReports":"c1132aa0","dashboard":"453671a4","disciplines":"79414863","divisions":"34b5ced9","pointsTable":"589c4774","reports":"67f48250","tutorials":"2e4726d2","wavesCompetitionsEntries":"f56201bb","wavesCompetitionsEventProgress":"c6cb4668","wavesCompetitionsMarshalling":"651902ed","wavesCompetitionsWavesResults":"e033dc39","documentation":"31d6cfe0","login":"8322f101","siteSettings":"613be94b","slsnz":"49ada49d","userProfile":"4473ee4f","waves":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
